<template>
    <article v-loading="loading">
        <header :style="'background-image: url('+logoImage+')'">
            <div class="row d-flex justify-content-center">
                <h1>Site Search</h1>
                <!--<div class="col-2 search-summary" v-show="results.length">-->
                    <!--<p><strong>{{total}}</strong> search Results for: </p>-->
                <!--</div>-->
                <!--<div class="col-6 text-left search-term">-->
                    <!--<p>{{queryHeader}}</p>-->
                <!--</div>-->
            </div>
        </header>
        <div class="filter-bar mb-4">
            <div class="container" >
                <form class="row d-flex justify-content-center">
                    <div class="col-6">
                        <input type="text" v-model="query" class="form-control">
                    </div>
                    <div class="col-2">
                        <button  class="btn btn-success btn-search"
                                 @click.prevent="search"
                                 :disabled="disabledSearchBtn">
                            Search
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <slot :data="slotData"></slot>
        <div class="row mb-5">
            <div class="col text-center">
                <button class="btn btn-default btn-success btn-next"
                        v-show="searching"
                        @click="search"
                        :disabled="!disabledLoadMoreBtn">load more</button>
            </div>
        </div>
    </article>
</template>

<script>
    export default {
        mounted(){

            this.routes = {
                get : window.App.routes.api.search,
                show : window.App.routes.web.resources
            };

            if(this.initQuery!==""){
                this.query = this.initQuery;
                this.search();
            }
        },
        props:{
            logoImage:{
                default:''
            },
            initQuery:{
                default:null
            }

        },
        data(){
            return {
                newSearch:true,
                query:'',
                current_query:'',
                routes:{},

                current_page:1,
                next_page:2,
                per_page:12,
                total:0,
                searching:false,
                results:[],

                loading:false,
            };
        },
        watch:{
            query(){
                this.newSearch=true;
            }
        },
        computed:{
            slotData(){
                return {
                    showRoute:this.routes.show,
                    results:this.results,
                    searching:this.searching,
                };
            },
            disabledSearchBtn(){
                return this.query.trim().length && !this.newSearch;
            },
            disabledLoadMoreBtn(){
                return this.total  > (this.current_page*this.per_page);
            },
            params(){
                this.next_page = this.newSearch? 1 : this.next_page;
                if (this.newSearch){}
                return { params:{
                    query:this.query,
                    per_page:this.per_page,
                    page:this.next_page}
                }
            },
            queryHeader(){
                return this.current_query.length > 200 ? this.current_query.substr(0,300)+"..." : this.current_query;
            }
        },
        methods:{
            search(){
                let vm = this;
                vm.loading=true;
                axios.get(vm.routes.get,this.params).then(response=>{
                    // console.log(response);
                    vm.searching = true;
                    if(vm.newSearch){
                        vm.results=response.data.data.data;
                    }else{
                        vm.results = vm.results.concat(response.data.data.data);
                    }
                    vm.newSearch = false;
                    vm.current_page=parseInt(response.data.data.pagination.current_page);
                    vm.next_page=parseInt(response.data.data.pagination.current_page)+1;
                    vm.total=response.data.data.pagination.total;
                    vm.loading=false;
                    vm.current_query = vm.query;
                    let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?query='+ encodeURI(this.query);
                    window.history.pushState({path:newurl},'',newurl);
                }).catch(e=>{
                    vm.loading=false;
                    console.log(e)
                });
            },
            loadMore(){},
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/views/search/SearchPage.vue